import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";
import EstablishmentCategoryFormWrapper from "../../../../Common/EstablishmentCategoryFormWrapper";

type EditAdressFormProps = {
    onSubmit: (data: any) => void;
    defaultValue: {
        region: string;
        establishmentType: string;
        establishmentGroup: string;
    };
};

export default function EditCategoryForm({
    onSubmit,
    defaultValue,
}: EditAdressFormProps) {
    return (
        <Box className="profil-form-root">
            <EstablishmentCategoryFormWrapper
                defaultValues={defaultValue}
                onSubmit={onSubmit}
                className="profil-form-container"
                formActionComponents={{
                    submit: (
                        <CustomButton
                            type="submit"
                            label="Enregister"
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                    cancel: (
                        <CancelModalButton
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                }}
                classes={{
                    categoryFormElements: {
                        selectpx: {
                            border: "2px solid  #E3E6E8",
                        },
                    },
                }}
                categoryWithName={true}
            />
        </Box>
    );
}
